import { type ReactElement } from 'react';
import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';
import { type ProviderSubscription } from '@marketplace/contracts';
import { billingPath, gateStateOf } from './billing.js';

/**
 * `W5-T13` §4.6 — on `/account` and `/account/pro`, while the provider is not entitled: one status
 * line, which is the way to the billing page. `null` is no line: a client (`403`), a provider role
 * with no profile (`409`) and an API that failed all leave the page what it was.
 */
export function SubscriptionAccountLine({
  subscription,
  locale,
}: {
  subscription: ProviderSubscription | null;
  locale: string;
}): ReactElement | null {
  const { t } = useTranslation();
  if (gateStateOf(subscription) === null) return null;

  return (
    <p className="mp-lead" data-testid="subscription-account-line">
      <Link to={billingPath(locale)}>{t('billing.gate.account_line')}</Link>
    </p>
  );
}
